import { render, staticRenderFns } from "./NormalReview.vue?vue&type=template&id=bcf76526"
import script from "./NormalReview.vue?vue&type=script&lang=js"
export * from "./NormalReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports